import type { IGroupCorrection } from "../../group-corrections";
import type { ISelfEvaluationResource } from "../../self-evaluations";
import type { ISkill } from "../../skills";
import { IHydraList } from "../../types";
import type { IUser } from "../../users";
import { createApiQueryHook, type IApiQueryFunction, type IOrderable, mapOrder } from "../../utils/api";
import { mapRelationalFilter, type RelationalFilter } from "../../utils/filters";
import { serialize } from "../../utils/url";
import type { IWorkItem } from "../../works";
import type { IFollowUp } from "../types/IFollowUp";

export interface IFollowUpWithSelfEvaluationCorrectionListQueryParameters extends IOrderable<"periodStart"> {
    filters?: {
        learner?: RelationalFilter<IUser>;
        skill?: RelationalFilter<ISkill>;
    };
}

export type IFollowUpWithSelfEvaluationCorrectionListQueryResult = IHydraList<
    IFollowUp | ISelfEvaluationResource | IGroupCorrection | IWorkItem
>;

const mapFilters = (filters: IFollowUpWithSelfEvaluationCorrectionListQueryParameters["filters"]) => {
    const { learner, skill } = filters ?? {};

    return {
        "learner.uuid": mapRelationalFilter(learner),
        "skill.uuid": mapRelationalFilter(skill),
    };
};

export const followUpWithSelfEvaluationCorrectionListQuery: IApiQueryFunction<
    IFollowUpWithSelfEvaluationCorrectionListQueryParameters
> = ({ order, filters }) => ({
    method: "GET",
    url: `/follow_ups/with_self_evaluation/with_correction${serialize(
        {
            ...mapFilters(filters),
            ...mapOrder(order),
        },
        true,
    )}`,
});

export const useFollowUpWithSelfEvaluationCorrectionListQuery = createApiQueryHook<
    IFollowUpWithSelfEvaluationCorrectionListQueryParameters,
    IFollowUpWithSelfEvaluationCorrectionListQueryResult
>(followUpWithSelfEvaluationCorrectionListQuery);
